var EventHandler = (function(){
    var EventHandler = function(context){
        this.context = context;
        this.events = {};
    };

    EventHandler.prototype.on = function(name, fn){
        if (!this.events[name]) {
            this.events[name] = [fn];
        } else {
            this.events[name].push(fn);
        }
    };

    EventHandler.prototype.trigger = function(name, params){
        if (this.events[name]) {
            for (var i = 0; i < this.events[name].length; i++) {
                this.events[name][i].apply(this.context, [params || null]);
            }
        }
    };

    return {
        init: function (O) {
            O.on = function (name, fn) {
                if (!this._event) { this._event = new EventHandler(this); }

                this._event.on(name, fn);
            };

            O.trigger = function (name, params, retroative) {
                if (!this._event) { this._event = new EventHandler(this); }

                this._event.trigger(name, params);

                if (retroative && this.parent){
                    this.parent.trigger(name, params);
                }
            };
        }
    };
})();

const callbacks = [];

var Player = (function($, EventHandler, window, document, undefined) {
    function Player(el, videoId, videoSlug) {
        var _this   = this;
        var $player = $('<div>');

        _this.videoId   = videoId;
        _this.videoSlug = videoSlug;

        Object.defineProperty(_this, 'duration', {
            get: function () {
                return _this.player.getDuration();
            }
        });

        let to;
        const onProgress = (currentTime, duration) => {
            const progress = Math.max(_this._progress, Math.floor(currentTime / duration * 100));
            const triggers = [25, 50, 75];
            const trigger = triggers.reduce((acc, v) => v < progress ? v : acc, 0);

            if (_this._progress < trigger) {
                _this._progress = trigger;

                _this.trigger(`progress:${trigger}`);
            }
        };

        _this._progress = 0;

        _this.on('ended', () => {
            clearInterval(to);

            _this.trigger(`progress:100`);
        });

        _this.on('playing', () => {
            clearInterval(to);
            to = setInterval(() => onProgress(_this.player.getCurrentTime(), _this.player.getDuration()), 250);
        });

        _this.on('paused', () => {
            clearInterval(to);
        });

        $player.appendTo(el);

        _this.player = new YT.Player($player.get(0), {
            height: '100%',
            width: '100%',
            videoId: videoId,
            playerVars: { 'showinfo': 0, 'rel': 0, 'iv_load_policy': 3, 'playsinline': 1 },
            events: {
                onReady: function (e) {
                    _this.trigger('ready');
                },
                onStateChange: function (e) {
                    switch (e.data) {
                        case YT.PlayerState.PLAYING:    _this.trigger('playing'); break;
                        case YT.PlayerState.PAUSED:     _this.trigger('paused'); break;
                        case YT.PlayerState.ENDED:      _this.trigger('ended'); $document.trigger('video-ended', [_this.videoId]); break;
                        case YT.PlayerState.BUFFERING:  _this.trigger('buffering'); break;
                        case YT.PlayerState.CUED:       _this.trigger('cued'); break;
                    }
                }
            }
        });
    }

    Player.prototype.setVideo = function (videoId, videoSlug) {
        this.videoId = videoId;
        this.videoSlug = videoSlug;
        this._progress = 0;

        if (Is.mobile.ANY()) {
            this.player.cueVideoById(videoId);
        } else {
            this.player.loadVideoById(videoId);
        }
    };

    Player.prototype.play = function () {
        this.player.playVideo();
    };

    Player.prototype.pause = function () {
        this.player.pauseVideo();
    };

    Player.prototype.seek = function (n) {
        this.player.seekTo(n);
    };

    Player.loaded = false;

    Player.load = function(cb) {
        return new Promise((resolve, reject) => {
            if (!Player.loaded) {
                if(typeof window.onYouTubeIframeAPIReady !== 'undefined') {
                    callbacks.push(window.onYouTubeIframeAPIReady);
                }

                if (typeof cb !== 'undefined') {
                    callbacks.push(cb);
                }

                window.onYouTubeIframeAPIReady = function() {
                    Player.loaded = true;

                    $.each(callbacks, function (i) {
                        callbacks[i]();
                    });

                    resolve();
                };

                $.getScript('https://www.youtube.com/iframe_api');
            } else {
                if (typeof cb !== 'undefined') {
                    cb();
                }

                resolve();
            }
        });
    };

    EventHandler.init(Player.prototype);

    return Player;
})(jQuery, EventHandler, window, document, undefined);
